















import { Component, Vue } from 'vue-property-decorator';
@Component({
    data(){
        return {
            img:'https://source.qunarzz.com/site/images/wns/20220517-shijianchen-1.jpg'
        }
    },
    components: {
    }
})
export default class extends Vue {
}
